import createRequestSpecs from '@/app/service/request'
import config from '@/config/http'

export default createRequestSpecs(config)
